<template>
  <div class="jumbotron-img" :style="{'background-image': 'url(' + require('@/assets/img/fullwidth/jumbotron-pattern.png' ) + ')'}">
    <div class="jumbotron-text">
      {{ this.title }}
    </div>
  </div>

</template>

<script>
export default {
  name: 'Jumbotron',
  props: ['title']
}
</script>

<style scoped>
  .jumbotron-img {
    width: 100vw;
    height: 15vh;
    background-size: cover;
  }

  .jumbotron-text {
    position: absolute;
    left: 0;
    width: 100vw;
    z-index: 10;

    margin-bottom: 15em;

    color: white;
  }
  @media screen and (max-width: 767px) {
    .jumbotron-text {
      height: 3.4em;
      padding: 1.2em 15px;
      font-size: 2rem;
      font-weight: 600;
      line-height: 1.2;
    }
  }
  @media screen and (max-width: 1023px) and (min-width: 768px) {
    .jumbotron-text {
      height: 2.2em;
      padding: 0.6em 15px;
      font-size: 3rem;
      font-weight: 500;
      line-height: 1.2;
    }
  }
  @media screen and (min-width: 1023px) {
    .jumbotron-text {
      height: 2.2em;
      padding: 0.6em 30px;
      font-size: 4.5rem;
      font-weight: 500;
      line-height: 1.2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Jumbotron/Jumbotron.vue